<!-- Ported from the Polaris kit: src/product/components/ThreadEvent.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// Something that happened in a thread and nobody said: a handover, an assignment, a resolution. A small centered pill, colored by who did
// it so the thread can be scanned: Polaris AI in its own color (the brand gradient, or the color of its role), a human agent in carbon,
// the system in the notification blue. Built on the registry marker. A day or a divider stays a plain Marker.
import { computed } from 'vue';
import { ChatBot16, Information16, UserAvatar16 } from '@carbon/icons-vue';
import { Marker, MarkerContent, MarkerIcon } from '../ui/marker';

const props = defineProps({
  actor: { type: String, default: 'system' }, // ai | human | system
  role: { type: String, default: '' }, // service | sales | ecommerce | general | receptionist, for the AI
});
// written out in full: Tailwind reads class names from the source, so they cannot be assembled from the role
const ROLES = {
  service:
    '[background:var(--polaris-bubble-service)_border-box] text-[color:var(--polaris-bubble-service-fg)]',
  sales:
    '[background:var(--polaris-bubble-sales)_border-box] text-[color:var(--polaris-bubble-sales-fg)]',
  ecommerce:
    '[background:var(--polaris-bubble-ecommerce)_border-box] text-[color:var(--polaris-bubble-ecommerce-fg)]',
  general:
    '[background:var(--polaris-bubble-general)_border-box] text-[color:var(--polaris-bubble-general-fg)]',
  receptionist:
    '[background:var(--polaris-bubble-receptionist)_border-box] text-[color:var(--polaris-bubble-receptionist-fg)]',
};
const look = computed(() => {
  if (props.actor === 'ai')
    return (
      ROLES[props.role] ||
      '[background:var(--polaris-bubble-ai)_border-box] text-[color:var(--polaris-bubble-ai-fg)]'
    );
  if (props.actor === 'human')
    return '[background:var(--polaris-bubble-agent)_border-box] text-[color:var(--polaris-bubble-agent-fg)]';
  return 'bg-polaris-info text-polaris-info-foreground';
});
const icon = computed(
  () => ({ ai: ChatBot16, human: UserAvatar16 })[props.actor] || Information16
);
</script>

<template>
  <Marker
    class="type-polaris-caption mx-auto w-fit max-w-full justify-center rounded-full px-3 py-1"
    :class="[look]"
    :data-thread-event="actor"
  >
    <MarkerIcon><component :is="icon" aria-hidden="true" /></MarkerIcon>
    <MarkerContent><slot /></MarkerContent>
  </Marker>
</template>
